export default __webpack_public_path__ + "static/media/logo_dark.61775e29.png";